const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-7b9b5322-c5fa-40a8-b9ac-6ddfd4d4ce3c {\n        fill: #5e3524;\n      }\n\n      .uuid-fad66850-9772-4eff-a8b6-f987ab0037f1, .uuid-fef34b5d-8965-405a-b9d4-9f94f92ab7ec {\n        fill: none;\n        stroke: #e8e4db;\n        stroke-miterlimit: 10;\n      }\n\n      .uuid-fef34b5d-8965-405a-b9d4-9f94f92ab7ec {\n        stroke-width: 2px;\n      }\n    "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-df59e33d-e032-4f0e-bd89-8f859c88c44a",
  "data-name": "Circles"
}, /*#__PURE__*/React.createElement("circle", {
  className: "uuid-7b9b5322-c5fa-40a8-b9ac-6ddfd4d4ce3c",
  cx: 22,
  cy: 21.95,
  r: 22
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-c316f960-1ead-43f4-9a01-68b31e7f85a5",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "uuid-fef34b5d-8965-405a-b9d4-9f94f92ab7ec",
  d: "M36.06,19.11v6.04c0,2-1.62,3.62-3.63,3.62h-3.15c-1.33,0-2.63-.4-3.72-1.15-.57-.38-1.06-.84-1.48-1.37-.49-.62-1.44-.62-1.93,0-.42.53-.92.99-1.48,1.37-1.1.75-2.4,1.15-3.72,1.15h-4.08c-1.49,0-2.7-1.21-2.7-2.7v-6.97c0-2,1.62-3.62,3.62-3.63h18.65c2,0,3.63,1.63,3.63,3.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-fad66850-9772-4eff-a8b6-f987ab0037f1",
  d: "M23.18,18.03h8.41c1.18,0,1.78.9,1.78,2.01v4.44c0,1.11-.76,1.83-1.95,1.85-1.12.02-3.29-.02-6.08-2.54-.31-.28-.66-.51-1.23-.86-.2-.12-.58-.34-.99-.34s-.8.22-.99.34c-.57.35-.97.61-1.23.86-2.74,2.57-4.96,2.56-6.08,2.54-1.18-.02-1.96-.74-1.96-1.85v-4.44c0-1.11.61-2.01,1.79-2.01h8.54"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-fad66850-9772-4eff-a8b6-f987ab0037f1",
  d: "M11.19,16.57v-7.21c0-.92.74-1.65,1.65-1.65s1.65.74,1.65,1.65v6.12"
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-fad66850-9772-4eff-a8b6-f987ab0037f1",
  x1: 10.78,
  y1: 10.38,
  x2: 14.09,
  y2: 10.38
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-fad66850-9772-4eff-a8b6-f987ab0037f1",
  x1: 10.78,
  y1: 12.32,
  x2: 14.09,
  y2: 12.32
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-fad66850-9772-4eff-a8b6-f987ab0037f1",
  d: "M14.2,28.78v2.3c0,1.16.97,2.21,2.16,2.66,1.17.44,2.54.19,3.44-.62.43-.4.86-1.42.86-1.43.23-.61.73-1.45,1.61-1.45s1.62.66,1.62,1.47v.05h0s-.03.24-.05.31c-.22,1.18-.84,2.27-1.77,3.11-1.19,1.09-2.81,1.71-4.5,1.71-1.69,0-3.31-.62-4.5-1.71s-1.86-2.56-1.87-4.1v-2.88"
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-fad66850-9772-4eff-a8b6-f987ab0037f1",
  x1: 19.65,
  y1: 33.32,
  x2: 22.48,
  y2: 34.78
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-fad66850-9772-4eff-a8b6-f987ab0037f1",
  x1: 20.75,
  y1: 31.73,
  x2: 23.53,
  y2: 33.09
}));
function SvgRepozeIconCategoryHobbies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepozeIconCategoryHobbies);
export default __webpack_public_path__ + "static/media/repoze_icon_category-hobbies.b55d98f1e9c67af1eb57110e637049bd.svg";
export { ForwardRef as ReactComponent };